import axios from "axios";
import { API_BASE_URL } from "./config";
axios.defaults.timeout = 10000;
// axios.defaults.baseURL = '/api'

export const getUserList = params =>{
    return axios.post(`${API_BASE_URL}/user/selectUser`,params)
    // return axios.get("http://192.168.8.200")
}

export const deleteUserById = params =>{
    return axios.post(`${API_BASE_URL}/user/deleteUserById`,params)
}

export const updateUserById = params =>{
    return axios.post(`${API_BASE_URL}/user/updateUserById`,params)
}

export const selectUserByConditions = params =>{
    return axios.post(`${API_BASE_URL}/user/selectUserByConditions`,params)
}

export const insertUser = params =>{
    return axios.post(`${API_BASE_URL}/user/insertUser`,params)
}

export const Login = params =>{
    return axios.post(`${API_BASE_URL}/user/Login`,params)
}